export default {
  api: '/api',
  bpi: window.location.hostname === 'localhost' ? '/bpi' : '',
};
